import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web'
import LoaderLottie from 'assets/lottie-loader.json'
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: "120px",
        width: "100%",
    },
}));

const LP = (props) => {
    // const {containerRef}
    const { className } = props;
    const classes = useStyles();

    const containerRef = useRef<HTMLDivElement>(null)
    const animationRef = useRef<any>(null)

    useEffect(() => {
        if (!containerRef.current) return

        animationRef.current = lottie.loadAnimation({
            animationData: LoaderLottie,// the path to the animation json
            container: containerRef.current, // the dom element that will contain the animation
            renderer: 'canvas',
            loop: true,
            autoplay: true,
        });


        return () => {
            animationRef.current?.destroy();
            animationRef.current = null;
        }
    }, [])

    return (
        <div ref={containerRef} className={`${classes.root} ${className}`} />
    )
}

export const LottiePlayer = React.memo(LP)